import { FC } from 'react';
import { Center, Spinner, VStack, Text } from '@chakra-ui/react';
import { LogoIcon } from '../logo';

export const LoadingScreen: FC = () => {
  return (
    <Center minH="100vh">
      <VStack spacing={6}>
        <LogoIcon />
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
        />
        <Text color="gray.500" fontSize="sm">
          Loading...
        </Text>
      </VStack>
    </Center>
  );
};